const MESSAGE_SENDER_TYPES = {
    USER: "user",
    BOT: "bot",
}
export default MESSAGE_SENDER_TYPES;
